<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
 <v-card class="lighten-4 pa-3" dark color="rgba(29,27,65,.6)" style="height:100%; min-height: 420px;">
   <!-- <div class="subheading pa-1" style="font-weight: 100; text-transform: uppercase;">Province</div> -->
   <v-row class="mt-0">
      <v-col cols="4" md="2" xl="2" class="pa-0 ma-0 text-left">
        <div class="pl-5 caption grey--text" 
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '12px !important', 'font-weight': '400', 'text-transform': 'uppercase' }">
          Province
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div class="caption grey--text" 
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '12px !important', 'font-weight': '400', 'text-transform': 'uppercase' }">
          Confirmed
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div class="caption grey--text" 
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '12px !important', 'font-weight': '400', 'text-transform': 'uppercase' }">
          Recovered
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div class="caption grey--text" 
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '12px !important', 'font-weight': '400', 'text-transform': 'uppercase' }">
          Deaths
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div class="caption grey--text" 
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '12px !important', 'font-weight': '400', 'text-transform': 'uppercase' }">
          Active
        </div>
      </v-col>
      <v-col cols="2" xl="4" class="pa-0 ma-0 text-center">
        <div class="caption grey--text" style="font-size: 12px !important;font-weight: 400; text-transform: uppercase;">
          
        </div>
      </v-col>
      <v-col cols="2" xl="2" class="pa-0 ma-0 text-center">
        <div class="caption grey--text text--lighten-1" style="font-size: 12px !important;font-weight: 400; text-transform: uppercase;">
        </div>
      </v-col>
    </v-row>
   <v-row v-for="prov in provinces" :key="prov.province" class="mt-3">
      <v-col cols="4" md="2" xl="2" class="pa-0 ma-0 text-left">
        <div class="pl-5">
          <div class="caption grey--text text--lighten-1" style="font-size: 12px !important;font-weight: 300;">
            <v-icon dark :color="prov.color" size="20" class="mr-1" v-show="$vuetify.breakpoint.xl">remove</v-icon>
            {{prov.province}}
          </div>
          <!-- <v-btn v-show="$vuetify.breakpoint.smAndDown" v-if="prov.hasBreakdown" small text color="blue" @click="viewBreakdown(prov)">More</v-btn>
          <div v-else class="mt-3">&nbsp;</div> -->
          <div v-show="$vuetify.breakpoint.smAndDown" v-if="prov.increase != 0" class="caption pink--text text--lighten-3" style="font-size: 10px !important;">{{'+ ' + getNumberDisplay(prov.increase)}}</div>
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div>
          <div class="caption blue--text text--lighten-2" style="font-size: 12px !important; font-weight: 300;">{{getNumberDisplay(prov.confirmed_count)}}</div>
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div>
          <div class="caption green--text text--lighten-1" style="font-size: 12px !important; font-weight: 300;">{{getNumberDisplay(prov.recovered_count)}}</div>
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div>
          <div class="caption pink--text text--lighten-2" style="font-size: 12px !important; font-weight: 300;">{{getNumberDisplay(prov.deceased_count)}}</div>
        </div>
      </v-col>
      <v-col cols="2" xl="1" class="pa-0 ma-0 text-center">
        <div>
          <div class="caption orange--text text--lighten-2" style="font-size: 12px !important; font-weight: 300;">{{getNumberDisplay(prov.active_count)}}</div>
        </div>
      </v-col>
      <v-col cols="2" xl="4" class="pa-0 ma-0 text-center" v-show="$vuetify.breakpoint.xl">
        <div class="pl-5 pb-1 mt-0">
          <apexchart type="bar" height="6" :options="chartOptions" :series="prov.series"></apexchart>
        </div>
      </v-col>
       <!-- <v-col cols="2" xl="2" class="pa-0 ma-0 text-center pr-2" v-show="$vuetify.breakpoint.mdAndUp">
        <v-btn v-if="prov.hasBreakdown" small depressed color="blue darken-4" @click="viewBreakdown(prov)">More</v-btn>
        <span v-else>-</span>
      </v-col> -->
      <v-col cols="2" xl="2" class="pa-0 ma-0 text-center pr-2" v-show="$vuetify.breakpoint.mdAndUp">
        <div v-if="prov.increase != 0" class="caption pink--text text--lighten-3" style="font-size: 10px !important;">{{'+ ' + getNumberDisplay(prov.increase)}}</div>
      </v-col>
    </v-row>
    <v-row v-show="selectedProvince !== ''" class="mt-4">
      <v-col cols="12" lg="3">
        <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
          <div><v-icon dark size="40" color="purple lighten-2">place</v-icon></div>
          <div class="headline mt-3">{{selectedProvMost}}</div>      
          <div class="caption grey--text text--lighten-2 mt-2">MOST CONFIRMED CASES REGION</div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">person</v-icon></div>
            <div class="headline mt-3">{{selectedProvPop + 'M'}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">TOTAL POPULATION</div>
          </v-card>
      </v-col>
      <v-col cols="12" lg="3">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">people</v-icon></div>
            <div class="headline mt-3">{{selectedProvPopPerc + '%'}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">% OF SA POPULATION</div>
          </v-card>
      </v-col>
      <v-col cols="12" lg="3">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">house</v-icon></div>
            <div class="headline mt-3">{{'Level ' + selectedProvLevel}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">LOCKDOWN RESTRICTION</div>
          </v-card>
      </v-col>
    </v-row>
    <ProvinceBreakdown ref="ProvinceBreakdown"/>
 </v-card>
</template>

<script>

import Papa from 'papaparse'
import ProvinceBreakdown from '@/components/ProvinceBreakdown.vue'

  export default {
    name: 'ProvinceList',
    data: () => ({
      provinces: [],
      breakdowns: [],
      breakdownRegions: [],
      selectedProvince: "",
      selectedProvMost: "",
      selectedProvPop: "",
      selectedProvPopPerc: "",
      selectedProvLevel: "",
      populationStats: [],
      chartOptions: {
        colors: ["#4CAF50", "#e91e63", "#ffa726"],
        chart: {
          background: "transparent",
          toolbar: {
            show: false
          },
          stacked: true,
          stackType: '100%',
           sparkline: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: ['#fff'],
            fontSize: '10px',
            fontWeight: '100',
          },
          // offsetX: 0,
          //offsetY: 1,
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex].data[0]
          }
        },
        grid: {
           show: false
        },
        legend: {
          show: false
        },
        tooltip: {
          x: {
            show: true
          },
          theme: "dark"
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          }
        },
        xaxis: {
          categories: [""],
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          }
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          }
        }
      }
    }),
    components: {
      ProvinceBreakdown
    },
    created() {
      //get the province breakdown data
      var self = this
      var d = new Date()
      var url = "data/toupdate/breakdown_summary.csv"
      url += "?etag=" + d.toISOString()

      Papa.parse(url, {
        download: true,
        header: true,
        skipEmptyLines: true,
        complete: function(results) {
          self.breakdowns = results.data
        }
      })  

      var url = "data/toupdate/breakdown_regions.csv"
      url += "?etag=" + d.toISOString()

      Papa.parse(url, {
        download: true,
        header: true,
        skipEmptyLines: true,
        complete: function(results) {
          self.breakdownRegions = results.data
        }
      })  

      //get the population details
      fetch('data/geo/sa_provinces.json')
        .then(response => {
          return response.json()
        })
        .then(data => {
          //get each prov
          for (var i = 0; i < data.features.length; i++) {
            var feat = data.features[i]

            //calc pop million
            var popCount = feat.properties.populationEstimate*1
            popCount = popCount/1000000
            popCount = parseFloat(popCount.toFixed(1))

            this.populationStats.push({province: feat.properties.province, populationCount: popCount, populationPerc: feat.properties.populationPerc*1})
          }          
        })
        .catch(err => {
          console.error(err)
      })
    },
    watch: {
      breakdowns: function(val) {
        //check for breakdown
        for (var i = 0; i < this.breakdowns.length; i++) {
          var br = this.breakdowns[i]

          var match = this.provinces.find(d => d.province === br.province)
          if(match) {
            //update
            match.hasBreakdown = true
          }
        }
      }
    },
    methods: {
      loadCases(data, provinceDisplay) {

        this.selectedProvince = ""
        this.selectedProvMost = ""
        this.selectedProvPop = ""
        this.selectedProvPopPerc = ""
        this.selectedProvLevel = ""

        var provs = [
          {province: 'Eastern Cape', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Free State', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Gauteng', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'KwaZulu-Natal', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Limpopo', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Mpumalanga', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Northern Cape', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'North West', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Western Cape', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0},
          {province: 'Unknown', confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:"", increase: 0}
        ]

        //check if only one prov selected
        if(provinceDisplay && provinceDisplay !== "") {
          //only show that one
          provs = [{province: provinceDisplay, confirmed_count: 0, color: '', deceased_count:0, hasBreakdown: false, recovered_count: 0, active_count: 0, confirmed_perc: 0, trend: [], series: [], level:""}]
        
          this.selectedProvince = provinceDisplay
        }
        else {
          this.selectedProvince = ""
        }

        //first get the distinct dates
        var dates = [];
        dates = Array.from(new Set(data.map(summ => summ.date))).map(date => {
          return date;
        });

        //find the date of the last entry
        var lastCaseDate = dates[dates.length - 1]

        //find the date of the prev entry
        var prevCaseDate = dates[dates.length - 2]

        //loop and add to the count per prov
        for (var i = 0; i < provs.length; i++) {
          var prov = provs[i]
          
          var match = data.find(c => c.date === lastCaseDate && c.region === prov.province)
          prov.confirmed_count = match.confirmed*1
          prov.deceased_count = match.deceased*1
          prov.recovered_count = match.recovered*1
          prov.active_count = prov.confirmed_count - prov.deceased_count - prov.recovered_count
          prov.level = match.level

          //find the increase
          var prevmatch = data.find(c => c.date === prevCaseDate && c.region === prov.province)
          var prevconfirmed = prevmatch.confirmed*1
          var delta = prov.confirmed_count - prevconfirmed
          prov.increase = delta

          //series data
          prov.series = [{name: "Recovered", data: [prov.recovered_count]}, {name: "Deaths", data: [prov.deceased_count]}, {name: "Active", data: [prov.active_count]}]

          //if a prov is selected get quick stats level
          if(this.selectedProvince !== "") {
            this.selectedProvLevel = match.level
          }
        }

         //check for breakdown
        for (var i = 0; i < this.breakdowns.length; i++) {
          var br = this.breakdowns[i]

          var match = provs.find(d => d.province === br.province)
          if(match) {
            //update
            match.hasBreakdown = true
          }
        }

        //if a prov is selected get quick stats
        if(this.selectedProvince !== "") {
          //get most region
          var dists = [];
          
          //filter out this province data only
          var provData = this.breakdownRegions.filter(d => d.province === this.selectedProvince);
          
          for (var i = 0; i < provData.length; i++) {
            var match = dists.find(
              d => d.district_munic === provData[i].district_munic
            );
            if (match) {
              //update the record
              match.district_munic_confirmed += provData[i].confirmed * 1;
            } 
            else {
              //not found
              dists.push({district_munic: provData[i].district_munic, district_munic_confirmed: provData[i].confirmed * 1});
            }
          }

          //sort dists
          dists = dists.sort(function(a, b) 
          {
            a = a.district_munic_confirmed
            b = b.district_munic_confirmed
            return a > b ? -1 : a < b ? 1 : 0
          })

          if(dists.length > 0) {
            this.selectedProvMost = dists[0].district_munic
          }
          else {
            this.selectedProvMost = "Unknown"
          }

          //get population stats
          var match = this.populationStats.find(d => d.province === this.selectedProvince)
          if(match) {
            this.selectedProvPop = match.populationCount
            this.selectedProvPopPerc =  match.populationPerc
          }

        }

        //sort by count desc
        provs = provs.sort(function(a, b) 
        {
          a = a.confirmed_count
          b = b.confirmed_count
          return a > b ? -1 : a < b ? 1 : 0
        })

        //filter out no data entries
        provs = provs.filter(d => d.confirmed_count > 0 || d.deceased_count > 0 || d.recovered_count > 0)

        //loop through provs and assign a color
        var cols = ['#7105a2', '#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#fde0dd', '#fff7f3', '#fff7f3']
        for (var i = 0; i < provs.length; i++) {  
          provs[i].color = cols[i]
        }

        //set the data
        this.provinces = provs

        var self = this
        setTimeout(function() {
          self.$emit("resize")
        }, 5000)        
      },
      viewBreakdown(prov) {
        //get the province stats
        var match = this.breakdowns.find(d => d.province === prov.province)
        if(match) {

          //get the national prov count
          var matchNat = this.provinces.find(d => d.province === prov.province)
          var natCount = "-"
          if(matchNat) {
            natCount = matchNat.confirmed_count
          }

          //get the additional quick stats
          var mostRegion = ""
          var popCount = ""
          var popPerc = ""
          var lev = ""

          //get most region
          var dists = [];
          
          //filter out this province data only
          var provData = this.breakdownRegions.filter(d => d.province === prov.province);
          
          for (var i = 0; i < provData.length; i++) {
            var matchd = dists.find(
              d => d.district_munic === provData[i].district_munic
            );
            if (matchd) {
              //update the record
              matchd.district_munic_confirmed += provData[i].confirmed * 1;
            } 
            else {
              //not found
              dists.push({district_munic: provData[i].district_munic, district_munic_confirmed: provData[i].confirmed * 1});
            }
          }

          //sort dists
          dists = dists.sort(function(a, b) 
          {
            a = a.district_munic_confirmed
            b = b.district_munic_confirmed
            return a > b ? -1 : a < b ? 1 : 0
          })

          if(dists.length > 0) {
            mostRegion = dists[0].district_munic
          }
          else {
            mostRegion = "Unknown"
          }

          //get population stats
          var matchp = this.populationStats.find(d => d.province === prov.province)
          if(matchp) {
            popCount = matchp.populationCount
            popPerc =  matchp.populationPerc
          }

          //get level
          lev = matchNat.level

          this.$refs.ProvinceBreakdown.loadProvince(match, natCount, this.breakdownRegions, mostRegion, popCount, popPerc, lev)

          //post the GA
          gtag('event', 'breakdown', {
            'event_category' : prov.province,
            'send_to': 'UA-161523063-1'
          });
        }
      },
      getNumberDisplay(number) {
        return number.toLocaleString('en').replace(/\,/g, ' ')   
      }
    }
  }
</script>
